import { Component, DestroyRef, forwardRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rms-search-input',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, TranslateModule],
  templateUrl: './search-input.component.html',
  styles: `
    :host {
      display: block;
    }
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchInputComponent),
      multi: true,
    },
  ],
})
export class SearchInputComponent implements ControlValueAccessor {
  @Input() public placeholder = 'search-input.type-to-search';
  @Input() public ariaLabel?: string;

  public readonly formControl = new FormControl<string>('', { nonNullable: true });

  private readonly destroyRef = inject(DestroyRef);

  public onTouched?: () => void;

  private onChange?: (value: string) => void;

  constructor() {
    this.formControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.onChange?.(value);
    });
  }

  public writeValue(value: string): void {
    this.formControl.setValue(value ?? '', { emitEvent: false });
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable({ emitEvent: false }) : this.formControl.enable({ emitEvent: false });
  }
}
